import * as React from "react";
import { stylesheet } from "typestyle";
import { classNames } from "./utils.js";
export function TabBar({ children, className }) {
    return (React.createElement("nav", { className: classNames(styles.tabBar, className) }, children));
}
export function TabItem({ active, onClick, children }) {
    return (React.createElement("button", { className: classNames(styles.tabItem, active && styles.tabItemActive), onClick: onClick }, children));
}
const styles = stylesheet({
    tabBar: {
        borderBottom: "1px solid var(--color-separator)",
    },
    tabItem: {
        fontSize: "1.25em",
        color: "var(--color-foreground)",
        backgroundColor: "var(--color-background)",
        padding: "0.5em 1em",
        border: 0,
        marginLeft: "0.25em",
        borderBottom: "2px solid transparent",
    },
    tabItemActive: {
        color: "var(--color-primary)",
        borderBottom: "2px solid var(--color-primary)",
    }
});
//# sourceMappingURL=tabs.js.map